// @ts-strict-ignore
import { CurrentUser } from 'api/currentUser';
import { getJson, postJson } from 'utils/http';

export type Invite = {
  id: string;
  email: string;
  byUser: {
    id: string;
    name: string;
  };
  hooks: Array<{
    hookType: string;
    organization?: {
      id: string;
      name: string;
    };
  }>;
};
export const fetchInvite = (inviteId: string): Promise<Invite> =>
  getJson(`/data/website/invites/${inviteId}`).then(({ invite }) => invite);
export const acceptInvite = (inviteId: string): Promise<CurrentUser> =>
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2-3 arguments, but got 1.
  postJson(`/data/website/invites/${inviteId}`).then(({ user }) => user);
